import { ListItemIcon } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekListItemIcon = styled(ListItemIcon)(({ theme }) => ({
    minWidth: "unset !important",
}));

export { PeekListItemIcon, PeekListItemIcon as default };
